// theme/constants.js

export const CHIP_FONT_SIZE = {
  xs: "12px",
  sm: "13px",
  md: "14px",
};

export const STATUS_STYLES = {
  new: {
    label: "New",
    background: "#cce5ff",
    color: "#1c1c1c",
  },
  in_triage: {
    label: "In Triage",
    background: "#e3d3fd",
    color: "#1c1c1c",
  },
  blocked: {
    label: "Blocked",
    background: "#dc3545",
    color: "#ffffff",
  },
  waiting_on_customer: {
    label: "Waiting on Customer",
    background: "#fd7e14",
    color: "#1c1c1c",
  },
  complete: {
    label: "Complete",
    background: "#b5babe",
    color: "#1c1c1c",
  },
  news_releases_and_notices: {
    label: "News Releases and Notices",
    background: "#baf1e1",
    color: "#1c1c1c",
  },
  default: {
    label: "Unknown",
    background: "#e0e0e0",
    color: "#1c1c1c",
  },
};

export const IMPORTANCE_COLORS = {
  high: {
    background: "#dc3545",
    color: "#ffffff",
  },
  medium: {
    background: "#fcc190",
    color: "#1c1c1c",
  },
  low: {
    background: "#769c7f",
    color: "#ffffff",
  },
  default: {
    background: "#e0e0e0",
    color: "#1c1c1c",
  },
};

export const ASSIGNEE_STYLES = {
  background: "#b5babe",
  color: "#1c1c1c",
};